import { normalFetch } from '../../fetch-api/get';
import { useQuery } from 'react-query';


const PREDICTS_KEYS = {
    GET_TICKERS: 'get-pairs',
    GET_ASSISTANTS: "get-assistant"
}


const useGetTickers = () => {

    return useQuery(
        PREDICTS_KEYS.GET_TICKERS, () => normalFetch('market/predict/tickers'),
        {
            select: res => res?.data
        }
    )
}

const useGetAssistants = () => {

    return useQuery(
        PREDICTS_KEYS.GET_ASSISTANTS, () => normalFetch('market/predict/assistants'),
        {
            select: res => res?.data
        }
    )
}



export {
    useGetTickers,
    useGetAssistants
}